import { cn } from '@rocco/utils/cn';
import { LensSwitch } from '~/ui-rocco/components/LensSwitch';

export type GalleryView = 'gallery' | 'grid';

const OPTIONS: GalleryView[] = ['gallery', 'grid'];

/**
 * Gallery / Grid, on the shared travelling-lens switch.
 *
 * Centred over the gallery because it governs everything below it, not any one
 * module. Dark tone: the project page's ground is #181818.
 */
export const GalleryViewToggle = ({
    view,
    onChange,
}: {
    view: GalleryView;
    onChange: (next: GalleryView) => void;
}) => (
    <LensSwitch
        ariaLabel="Gallery layout"
        className="mx-auto"
        activeKey={view}
        items={OPTIONS.map((option) => ({
            key: option,
            render: (isActive: boolean) => (
                <button
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => onChange(option)}
                    className={cn(
                        'flex h-[2.75rem] cursor-pointer items-center justify-center rounded-[1rem] bg-transparent px-[1.5rem]',
                        'font-sans text-base capitalize transition-colors duration-200',
                        isActive
                            ? 'text-[#141414]'
                            : 'text-white/70 hover:text-white',
                    )}
                >
                    {option}
                </button>
            ),
        }))}
    />
);
